import { useDarkMode } from "../context/darkModeContext";
import "../css/Background.css";

const Background = (): JSX.Element => {
  const { darkMode } = useDarkMode();
  return (
    <div className={darkMode ? "background--darkmode" : "background"}></div>
  );
};

export default Background;
